export default __webpack_public_path__ + "media/images/images/doc-images/modern-build-process-a073e2ea13ab93bb4c94c1061ed23b47.png";